
import React from 'react';
import news from '../data/gallery-content'
import GalleryGrid from '../components/GalleryGrid'


const NewsPage = () => (
    <React.Fragment>
        <h2 className="page-heading">News</h2>
        <GalleryGrid articles={news} />
    </React.Fragment>
    
)

export default NewsPage;